import styled from "styled-components";
import colours from "styles/colours";

export const LinksContainer = styled.div`
  display: flex;
  gap: 2em;
  background: transparent;
  margin: 24px 0;
`;

export const LinkSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;

  ${LinksContainer} &:not(:last-child) {
    border-right: 1px solid ${colours.elexonBlue};
  }
`;

export const LinkContentDiv = styled.div`
  h3 {
    color: ${colours.elexonBlack};
    font-size: 1.25em;
    margin-bottom: 1em;
  }

  p {
    color: ${colours.darkGrey};
    font-size: 1em;
    padding-right: 2em;
    margin-bottom: 4em;
  }
`;
